import React, { useMemo } from "react";
import dayjs from "dayjs";
import Link from "next/link";
import Image from "next/image";
import { Button, Modal, Rating } from "@aqar-app/react-ui";
import { Icon } from "@/components/icon";
import { getElapsedTime } from "@/lib/dateHelpers";
import config from "@/common/config";
import ProfileCardSkeleton from "../ProfileCardSkeleton";
import UserInfo from "../constants";
import css from "./.module.scss";
import { ShowMore } from "@/components/Listing/showMore";
import UserReviewsModal from "@/components/Listing/ListingScreen/owner/UserReviewsModal";
import { OneFraction } from "@/lib/helpers";

function ProfileCard({ user, loading }) {
  const {
    name,
    img,
    review,
    reviewsCount,
    iam_verified: iamVerified,
  } = user || {};

  const userTags = useMemo(() => {
    const tags = UserInfo.filter((info) => user[info.key] === info.value) || [];

    if (!user?.last_seen) return tags;
    return [
      {
        label: getElapsedTime(user?.last_seen),
        icon: "Alarm",
      },
      ...tags,
    ];
  }, [user?.last_seen, UserInfo]);

  if (!user) return null;

  if (loading) {
    return <ProfileCardSkeleton />;
  }
  return (
    <div  itemScope className={css.card}>
      <div className={css.owner}>
        <div className={css.ownerImg}>
          <Image
            unoptimized
            src={`${config.IMAGES_CDN_BASE_URL}users/${img || null}`}
            alt="Profile Image"
            width={100}
            height={100}
          />
        </div>
        <div>
          <div className={css.userName}>
            {iamVerified ? (
              <Icon
                className={css.verifiedIcon}
                width={20}
                height={20}
                name="VerifiedListing-colored"
              />
            ) : null}
            <div className={css.userName}>
              <h2 itemProp="name" className={css.name}>{name || "مستخدم"}</h2>
              {user.status === 1 && (
                <svg
                  className={css.banned}
                  width={20}
                  height={20}
                  focusable="false"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path
                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
                    fill="#A51B1B"
                  />
                </svg>
              )}
            </div>
          </div>
        </div>
        {review && (
          <div
            itemProp="aggregateRating" itemScope itemType="https://schema.org/AggregateRating"
            className={"rating "+css.userReview}>
            {/*<Rating value={(user?.review / 5) * 100} count={5} />*/}
            {/*<span className={styles.count}>{`(${user.reviewsCount})`}</span>*/}
            <Icon width={15} height={15} name="v1/star" />
            <p
              className={css.reviewCount + " " + css.clickable}
              onClick={Modal.open(
                <UserReviewsModal
                  reviewsCount={reviewsCount}
                  review={OneFraction.format(review)}
                  userId={user.id}
                />,
              )}
            >
              <span itemProp="ratingValue">{OneFraction.format(review)}</span>
              <span itemProp="ratingCount"> التقييمات ({reviewsCount})</span>
            </p>
          </div>
        )}
        {!user?.review && (
          <div className={css.userReview}>
            <p>لا يوجد تقييم بعد</p>
          </div>
        )}
        {user.create_time ? (
          <div className={css.date}>{`الإنضمام: ${dayjs(
            user.create_time * 1000,
          ).format("ll")}`}</div>
        ) : null}
        {user.about && (
          <div className={css.description}>
            <ShowMore buttonText=" اقرأ المزيد">{user.about}</ShowMore>
          </div>
        )}
        <Link href={`/payment-gateway/broker-commission/${user?.user_id}`}>
          <Button theme="info" outline className={css.flex}>
            <Icon name="Fees-blue" width={16} height={16} />
            <span>دفع السعي</span>
          </Button>
        </Link>
        <ul className={css.userInfo}>
          {userTags.map((info) => {
            return (
              <li className={css.info} key={info.label}>
                <Icon
                  name={info.icon}
                  className={css.infoIcon}
                  width={25}
                  height={25}
                />
                <span className={css.InfoLabel}>{info.label}</span>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}

export default ProfileCard;
